// Captures external referrer + UTM params from the landing page URL into
// sessionStorage, then populates hidden form fields on connect so the
// POST includes attribution even if the user navigated around the site
// (via Turbo) before submitting the form.
//
// Usage: attach data-controller="attribution" to the <form>. Hidden fields
// must use the standard names: referrer, utm_source, utm_medium, etc.

import { Controller } from "@hotwired/stimulus";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];
const STORAGE_PREFIX = "fs_";

export default class extends Controller {
  connect() {
    try {
      this.captureFromUrl();
      this.populateFields();
    } catch (_) {
      // Best-effort — sessionStorage throws SecurityError in Safari private
      // browsing, cross-origin iframes, and some enterprise lockdowns.
      // Attribution is never worth breaking the page.
    }
  }

  captureFromUrl() {
    const params = new URLSearchParams(window.location.search);
    UTM_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) sessionStorage.setItem(STORAGE_PREFIX + key, value);
    });

    // Capture external referrer once per session — the first document.referrer
    // from a different origin is the one that matters for attribution.
    if (document.referrer && !sessionStorage.getItem("fs_referrer")) {
      try {
        if (new URL(document.referrer).hostname !== location.hostname) {
          sessionStorage.setItem("fs_referrer", document.referrer);
        }
      } catch (_) {
        /* invalid URL, skip */
      }
    }
  }

  populateFields() {
    const fields = ["referrer", ...UTM_KEYS];
    fields.forEach((name) => {
      const input = this.element.querySelector(`input[name="${name}"]`);
      const value = sessionStorage.getItem(STORAGE_PREFIX + name);
      if (input && value) input.value = value;
    });
  }
}
